export const DATE_INPUT_FORMAT_DAY_OF_WEEK = 'iii, MMM do, yyyy';
export const DATE_FORMAT_DAY_OF_WEEK = 'ddd, MMM Do, YYYY';
export const DATE_FORMAT_MONTH_YEAR = 'MMM Do, YYYY';
export const DATE_FORMAT_DATE_TIME = 'MMM Do, YYYY H:m';
export const INTERNATIONAL_DATE_FORMAT = 'dd/MM/yyyy';
export const INTERNATIONAL_MOMENT_DATE_FORMAT = 'DD/MM/YYYY';
export const STANDARD_DATE_FORMAT = 'DD/MM/yyyy';
